<template>
	<div class="message-group" :class="{owner}">
		<small class="label">
			{{userLabel}}: {{messagesGroup.user.name}} - {{messagesGroup.date | date}}
		</small>

		<div v-for="(message, i) in messagesGroup.messages" :key="i" class="message">
			<span class="text">{{message.text}}</span>
			<i class="time">{{message.creationDate | time}}</i>
			<span v-if="!chatGroup.firstUnseenMessage || message.id < chatGroup.firstUnseenMessage.id" class="material-icons message-seen-sign">done_all</span>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
export default {
	props: ['messagesGroup', 'chatGroup', 'owner'],
	computed: {
		userLabel() {
			return this.messagesGroup.user.blumarUser ? 'Blumar' : this.messagesGroup.user.guideProduct ? 'Guia' : 'Usuário';
		},
	},
	filters: {
		date(momentDate) {
			return momentDate.format('DD/MM/YYYY');
		},
		time(value) {
			return moment(value, 'DD/MM/YYYY HH:mm').format('HH:mm');
		},
	},
}
</script>

<style lang="scss" scoped>
.message-group {
	width: 60%;
	border-bottom: none;
	border-top: none;
}

.message-group.owner {
	margin-left: auto;
	.message {
		background: #aaa;
	}
}

.label {
	margin-left: 10px;
}

.message {
	display: grid;
	grid-template-columns: 1fr 35px;
	grid-template-rows: 1fr 20px;
	grid-template-areas: "text time" "text view";

	background: grey;
	padding: 5px 10px;
	color: white;
	border-radius: 5px;
}

.message:not(:last-of-type) {
	margin-bottom: 2px;
}

.message:first-of-type {
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
}

.message:last-of-type {
	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;
}

.text {
	grid-area: text;
}

.time {
	grid-area: time;
	font-size: .8rem;
	margin-left: auto;
}

.message-seen-sign {
	grid-area: view;
	font-size: 15px;
	align-self: flex-end;
	margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/blumar-chat/MessageGroup.vue